var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockedkeepStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.438 20.372v-5.62a8.89 8.89 0 018.89-8.89 8.874 8.874 0 018.89 8.89v5.62",
    fill: "none",
    stroke: "#4B4A5D",
    strokeWidth: 3.038,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.803 36.582a9.19 9.19 0 009.19-9.19v-6.081h-25v6.081a9.19 9.19 0 009.19 9.19h6.62z",
    fill: "none",
    stroke: "#4B4A5D",
    strokeWidth: 3.038,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.493,
    cy: 28.74,
    r: 2.29,
    fill: "#4B4A5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedkeepStyle);
export default __webpack_public_path__ + "static/media/locked.keepStyle.724c97a63f65b15156ed1f40e024aa10.svg";
export { ForwardRef as ReactComponent };